import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';

export const ClientInfoSection = ({ formData, set }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 1: CLIENT INFORMATION</h3>

    <div>
      <Label htmlFor="fullName" className="text-charcoal-ink">Full Name *</Label>
      <Input
        id="fullName"
        required
        value={formData.fullName}
        onChange={(e) => set('fullName', e.target.value)}
        className="bg-white border-stone-taupe/20"
      />
    </div>

    <div>
      <Label htmlFor="email" className="text-charcoal-ink">Email Address *</Label>
      <Input
        id="email"
        type="email"
        required
        value={formData.email}
        onChange={(e) => set('email', e.target.value)}
        className="bg-white border-stone-taupe/20"
      />
    </div>

    <div>
      <Label htmlFor="phone" className="text-charcoal-ink">Phone Number (optional)</Label>
      <Input
        id="phone"
        type="tel"
        value={formData.phone}
        onChange={(e) => set('phone', e.target.value)}
        className="bg-white border-stone-taupe/20"
      />
    </div>

    <div>
      <Label className="text-charcoal-ink mb-3 block">Preferred Method of Contact *</Label>
      <RadioGroup value={formData.contactMethod} onValueChange={(value) => set('contactMethod', value)}>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="email" id="email-contact" />
          <Label htmlFor="email-contact" className="text-charcoal-ink font-normal cursor-pointer">Email</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="text" id="text-contact" />
          <Label htmlFor="text-contact" className="text-charcoal-ink font-normal cursor-pointer">Text</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="either" id="either-contact" />
          <Label htmlFor="either-contact" className="text-charcoal-ink font-normal cursor-pointer">Either</Label>
        </div>
      </RadioGroup>
    </div>
  </div>
);

export const EventSection = ({ formData, set }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 2: EVENT DETAILS</h3>

    <div>
      <Label htmlFor="eventType" className="text-charcoal-ink">Type of Event *</Label>
      <select
        id="eventType"
        required
        value={formData.eventType}
        onChange={(e) => set('eventType', e.target.value)}
        className="w-full px-3 py-2 bg-white border border-stone-taupe/20 rounded-md text-charcoal-ink"
      >
        <option value="">Select event type</option>
        <option value="birthday">Birthday Party</option>
        <option value="wedding">Wedding</option>
        <option value="baby-shower">Baby Shower</option>
        <option value="bridal-shower">Bridal Shower</option>
        <option value="bachelorette">Bachelorette Party</option>
        <option value="graduation">Graduation</option>
        <option value="holiday">Holiday / Seasonal</option>
        <option value="other">Other</option>
      </select>
    </div>

    <div>
      <Label htmlFor="eventDate" className="text-charcoal-ink">Event Date *</Label>
      <Input
        id="eventDate"
        type="date"
        required
        value={formData.eventDate}
        onChange={(e) => set('eventDate', e.target.value)}
        className="bg-white border-stone-taupe/20"
      />
    </div>

    <div>
      <Label className="text-charcoal-ink mb-3 block">Is this a rush order? *</Label>
      <RadioGroup value={formData.rushOrder} onValueChange={(value) => set('rushOrder', value)}>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="no" id="no-rush" />
          <Label htmlFor="no-rush" className="text-charcoal-ink font-normal cursor-pointer">No</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="yes" id="yes-rush" />
          <Label htmlFor="yes-rush" className="text-charcoal-ink font-normal cursor-pointer">Yes (additional rush fee may apply)</Label>
        </div>
      </RadioGroup>
    </div>
  </div>
);
